import { graphql } from "gatsby";
import React from "react";
import { HomePageLayout } from "../components/layouts/HomePageLayout/HomePageLayout";
import { PageTitle, SEO } from "../modules/seo";

const IndexRoute = () => {
  return (
    <>
      <SEO title={PageTitle.Home} />
      <HomePageLayout />
    </>
  );
};

export const query = graphql`
  query HomePageQuery {
    allShopifyCollection {
      edges {
        node {
          id
          descriptionHtml
          handle
          title
        }
      }
    }
    shopifyBlog {
      id
    }
  }
`;

export default IndexRoute;
